(function() {

    'use strict';

    var CandidateSearchCtrl = function ($scope, $http) {
        $scope.formModel = {candidateName : ""};
        $scope.candidates =[];
        $scope.getCandidates = function(searchUrl) {
            $scope.candidates = {};
            $http.get( WEBAPP_PATH + searchUrl+'&term='+$scope.formModel.candidateName+'&myOUOnly='+$scope.formModel.myOUOnly).then(
                function(response){
                    var objectArr = [];
                    angular.forEach(response.data, function(resp){
                        var obj = {};
                        angular.forEach(resp, function(value, key){
                            this[key] = value;
                        }, obj);
                        objectArr.push(obj);
                    });
                    $scope.candidates = objectArr;
                }
            );
        }

        $scope.checkIfBookingDisabled = function(entitlementToWork, dob, address) {
            if(entitlementToWork && dob && address) {
                return false;
            }
            else {
                return true;
            }
        }
    }
    CandidateSearchCtrl.$inject = ['$scope', '$http'];
    angular.module('app').controller('CandidateSearchCtrl',CandidateSearchCtrl);
}());